export enum EnumLocalStorageKeys {
  IS_DASHBOARD_INTRO_CLOSED = 'is_dashboard_intro_closed',
  IS_HOW_DOES_IT_WORK_CLOSED = 'is_how_doest_it_work_closed',
  IS_HOW_GO_TO_NEXT_STEP = 'is_how_go_to_the_next_step',
  IS_COMPANY_ONBOARDING_BANNER_CLOSED = 'is_company-onboarding_banner_closed',
  IS_DEVELOPER_EXPERIENCE_ALERT_CLOSED = 'is_developer_experience_alert_closed',
  OAUTH_TOKEN_PART = 'auth0spajs',

  _TEST_KEY = 'test_key',
}
